import React, { useState } from 'react';
import '../Navbar/Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };
  const phoneClick = () => {
    window.location.href='tel:+919654945825';
  };
  return (
    <>
      <div>
        <header>
         <img src='logo.webp' loading="lazy" alt='logo' className='logo-header'/>
          <h1 className='head-h1'><span className='head-h1-span'>IRISH </span>PLATINUM</h1>
          <p className='head-p'>At Sector 10, Greater Noida West</p>
          <p onClick={phoneClick} className='h'>+91 96549 45825</p>
        </header>
        <nav>
          <ul className={isOpen ? 'active' : ''}>
           <li> <a href="#home" onClick={closeMenu}>Home</a></li>
           <li> <a href="#price" onClick={closeMenu}>Price</a></li>
           <li> <a href="#site&floor" onClick={closeMenu}>Site & Floor Plan</a></li>
            <li> <a href="#amenities" onClick={closeMenu}>Amenities</a></li>
            <li> <a href="#gallery" onClick={closeMenu}>Gallery</a> </li>
            <li> <a href="#location" onClick={closeMenu}>Location</a> </li>
         
           <li> <a href="#virtualsitetour" onClick={closeMenu}>Virtual Site Tour</a> </li>
           
            <li> <a href="#brochure" onClick={closeMenu}>Brochure</a> </li>
          </ul>
          <div className="handle" onClick={toggleMenu}>
            {isOpen ? 'Close' : 'Menu'}
          </div>
        </nav>
      </div>
    </>
  );
};

export default Navbar;
